import { Component, OnInit } from '@angular/core';
import { SuscriptionService } from 'src/app/service/suscription.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-connectnew-device',
  templateUrl: './connectnew-device.component.html',
  styleUrls: ['./connectnew-device.component.scss'],
  providers: [MessageService]
})
export class ConnectnewDeviceComponent implements OnInit {

  nombre: string = '';
  idsuscripcion: number = 0;
  checkedTerm: boolean = false;
  checkedTerminosCondicionesError: boolean = false; 
  index: number = 0;

  constructor(
    private suscriptionservice: SuscriptionService,
    private messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {
    // Establecer idiomas disponibles y el idioma por defecto
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('es');
  }

  ngOnInit(): void {
    if(this.suscriptionservice.dispositivo.id == 0){
      this.router.navigate(['/dashboard']);
      return;
    }
    this.nombre = this.suscriptionservice.dispositivo.nombre == null ? '' : this.suscriptionservice.dispositivo.nombre;
    this.index = this.suscriptionservice.dispositivo.index;
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  changetab(): void {
    this.checkedTerminosCondicionesError = false;
    if(!this.checkedTerm){
      this.checkedTerminosCondicionesError = true;
      this.messageService.add({ severity: 'warning', summary: this.translate.instant('TERMS'), detail: this.translate.instant('ACCEPT_TERMS') });
      return;
    }

    this.suscriptionservice.actualizarNombreSuscripcion(this.nombre, this.suscriptionservice.dispositivo.id).then(
      result => {
        const nombreAnterior = this.suscriptionservice.dispositivo.nombre;
        this.messageService.add({ severity: 'success', summary: this.translate.instant('DEVICE_SUCCESS'), 
          detail: this.translate.instant('DEVICE_NAME')+
          (nombreAnterior == null ? 'Guardado': nombreAnterior.trim() === this.nombre.trim() ? this.translate.instant('DEVICE_SAVED'): this.translate.instant('DEVICE_UPDATED'))+'!!' });
        setTimeout(() => {
          this.router.navigate(['/dashboard'], { queryParamsHandling: 'merge' })
        }, 3000);
      }
    )
  }
}
